import React from 'react'
import ContactBanner from '../Components/contactsection/ContactBanner'

function Contact() {
  return (
    <>
    <ContactBanner />
    </>
  )
}

export default Contact